/*************************************************************************
 *
 * KLEARNOW CONFIDENTIAL
 * __________________
 *
 *  Copyright (c) 2018 - 2020 KLEARNOW Corporation.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of KLEARNOW Corporation and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to KLEARNOW Corporation
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from KLEARNOW Corporation.
 */

import React, { Component } from 'react'
import { Form, Search, Icon, Popup } from 'semantic-ui-react'
import _ from 'lodash'
import 'react-semantic-ui-datepickers/dist/react-semantic-ui-datepickers.css'
import { getEntityList } from '../api/getEntrySummaryData'

const resultRenderer = ({ title, payload }) => <div>{`${payload} - ${title}`}</div>
const resultRendererNoPrefix = ({ title, payload }) => <div>{`${title}`}</div>

export class SearchDropDown extends Component {
  constructor() {
    super()
    this.state = {
      results: [],
      isLoading: false,
      portTitle: '',
      allresultss: [],
    }
    this.handleSearchChange = this.handleSearchChange.bind(this)
    this.handleResultSelect = this.handleResultSelect.bind(this)
    this.getEntityListAPI = _.debounce(this.getEntityListAPI.bind(this), 900, {
      leading: true,
      trailing: true
    })
  }

  componentDidMount() {
    if (this.props.value.id) {
        // if(this.props.hidePrefix){
        //   this.setState({ portTitle: `${this.props.value.title}` });
        // } else {
        //   this.setState({ portTitle: `${this.props.value.id} - ${this.props.value.title}` });
        // }
      this.getEntityListAPI(this.props.value.id, this.props.portType, true, this.props.fieldType);
    }
  }

  componentDidUpdate(prevProps) {
    let previousPortId = _.get(prevProps, 'value.id', '')
    let currentPortId = _.get(this.props, 'value.id', '')
    let differenttitle = this.props.value.title !=  prevProps.value.title;
    if (previousPortId !== currentPortId || differenttitle) {
      if (!currentPortId) {
        this.setState({
          portTitle: ''
        })
      } else {
        if(this.props.hidePrefix){
          this.setState({ portTitle: `${_.get(this.props, "value.title", "")}` });
        } else {
          this.setState({ portTitle: `${currentPortId} - ${_.get(this.props, "value.title", "")}` });
        }
      }
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.newValue !== this.state.newValue) {
      this.setState({ newValue: nextProps.newValue }, () => {
        this.props.fieldName === this.props.id + this.props.shipmentId && this.props.onChange(this.props.isInteger ? parseFloat(this.state.newValue.replace(/[^\d.-]/g, "")).toFixed(2) : this.state.newValue);
      })
    }
  }

  handleResultSelect = (e, { result }) => {
    const { fullPayload } = this.props;
    
    if(this.props.hidePrefix){
      this.setState({ portTitle: `${result.title}` });
    } else {
      this.setState({ portTitle: `${result.payload} - ${result.title}` });
    }

    this.props.onChange({
      id: result.payload,
      title: result.title,
      masterSet: true,
    });
    if(this.props.onBlur){
      if (fullPayload) this.props.onBlur(result);
      else this.props.onBlur(result.payload);
    }
  }


  getEntityListAPI(value, portType, replaceTitleYes, fieldType) {
    this.setState({ isLoading: true });
    getEntityList(value.split(",")[0], portType, this.props.id === "foreignPortOfLadingCode" ? "" : "US", fieldType, this.props.currentCountry_aa)
      .then((response) => {
        try {
          let portList= [];
          if(portType == 'PORT'){
            portList = response.data.eventMessage.ports.list.map((entity, index) => {
              //payloadcode!
              let myportName = entity.portName || "";
              let title = `${myportName?myportName:""} ${entity.portProvince ? ", "+entity.portProvince:''}`;
              return {
                key: index,
                title: title,
                payload: entity.portCode || entity.portScheduleKCode,
                portKxId: entity.portKxId,
                portTimeZone: entity.portTimeZone,
              };
            });
          }
          if(portType == 'AIRPORT'){
            let airportslist = _.get(response,"data.eventMessage.airports.list", []);
            portList = airportslist.map((airport, index) => {
            let airportcode = airport.airportCode || airport.airportScheduleKCode;
              let title = `${airportcode}, ${airport['airportName'].substring(0,20)}`;//SAN FRANCISCO, CA
              if(replaceTitleYes){
                this.setState({
                  portTitle:title
                })
              }
              return {
                key: index,
                title: title,
                payload: airportcode, //USA
                airportTimeZone: airport['airportTimeZone'],
                portKxId: airport.airportKxId
              };
            });
          }
          this.setState({allresultss:this.state.allresultss.concat(portList)})
          let portid = this.props.value && this.props.value.id;
          this.setState({
            results: portList,
            isLoading: false
          })
          portList.length === 1 && portid === portList[0].payload &&  this.setState({ portTitle: `${portList[0].payload} - ${portList[0].title}` });
        } catch (e) {
          console.error('Port List Error: ', e)
          return this.setState({
            results: [],
            isLoading: false
          })
        }
      })
      .catch(err => {
        console.log('  ERROR', err)
      })
  }

  handleSearchChange = (value, onFocus) => {
    if (!onFocus) {
      this.setState({
        portTitle: value
      })
    }
    if (value.length <= 0) {
      return this.setState({
        results: [],
        isLoading: false
      })
    } else return this.getEntityListAPI(value, this.props.portType, false, this.props.fieldType)
  }

  errorPopup = errors => {
    const error = errors.map((info, index) => {
      return (
        <div className='error' key={index}>
          * {info}
        </div>
      )
    })
    return (
      <Popup trigger={<Icon name='warning sign' color='red' />} content={error || ''} />
    )
  }
  render() {
    const {
      id,
      dateClass,
      label,
      width,
      isLabel,
      type,
      onChange,
      disabled,
      value,
      labelClassName,
      penClicked,
      setINPUTID,
      handleFocus,
      shipmentId,
      onBlur,
      validate,
      className,
      errors
    } = this.props
    let redBgColor = "";
    if(errors && errors.length){
      redBgColor = "redBgColor";
    }
    var renderrrr = this.props.hidePrefix?resultRendererNoPrefix:resultRenderer;
    return (
      <React.Fragment>
        {type !== 'date' && (
          <label
            htmlFor='floatField'
            className={
              labelClassName
                ? 'name-label es ' + labelClassName
                : 'name-label es'
            }
          >{(errors && errors.length) ? this.errorPopup(errors) : ''}
            {label}
          </label>
        )}
        <Form.Field className={dateClass} width={width}>
          {isLabel && <label size='small'> {label} </label>}
          <Search
            className={'search-port ' + className+' '+redBgColor}
            onResultSelect={this.handleResultSelect}
            loading={this.state.isLoading}
            resultRenderer={renderrrr}
            results={this.state.results}
            style={{ textTransform: 'uppercase !important', width: '100%' }}
            name={id + shipmentId}
            id={id + shipmentId}
            onMouseDown={e => {
              e.stopPropagation()
            }}
            fluid
            value={this.state.portTitle}
            onSearchChange={event => {
              this.handleSearchChange(event.target.value)
            }}
            disabled={disabled}
            onMouseDown={e => {
              e.stopPropagation()
              penClicked && penClicked(e)
            }}
            onFocus={event => {
              this.handleSearchChange(_.get(this.props, 'value.id', ''), true)
              handleFocus && handleFocus(event)
              setINPUTID && setINPUTID(id + shipmentId)
            }}
            onBlur={event => {
              if(this.props.noOnBlur)return;
              if (!event.target.value) { // If no value, save BLANK and empty field
                this.props.onBlur('_BLANK_')
                if (validate instanceof Function) {
                  validate(id, event.target.value)
                }
                this.setState({ portTitle: '' })
                this.props.onChange({
                  id: '',
                  title: '',
                  masterSet: false
                })
              } else {
                if (validate instanceof Function) {
                  validate(id, event.target.value)
                }
                if(this.props.value){
                  if (!this.props.value.id) { // IF no ID was selected, set the field to empty
                    this.setState({ portTitle: '' })
                  } else { // Else populate field with the ID selected
                    
                    let title = this.props.value.title;
                    if(!title && this.state.allresultss && this.state.allresultss.length){
                      let id = this.props.value.id;
                      title=(this.state.allresultss.find((a)=>a.payload == id)||{title:"Unknown"}).title;
                    }
                    if(this.props.hidePrefix){
                      this.setState({ portTitle: `${title}` });
                    } else {
                      this.setState({ portTitle: `${this.props.value.id} - ${title}` });
                    }
                  }
                }
              }
            }
            }
          />
        </Form.Field>
      </React.Fragment>
    )
  }
}

export default SearchDropDown
